import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';

// Images
import Mobile3 from './images/Whofolio_on_mobile_3.png';

class Simplicity extends Component {
  render() {
    return (
      <div className="simplicity">

        <div className="wrap">

          <Fade bottom>
          <img src={Mobile3} alt="whofolio on a mobile phone" />
          </Fade>

          <Fade right cascade>
          <div className="text-container">
            <h2><strong>simplicity</strong><br />in mind</h2>
            <h3>We built whofolio from the ground up, keeping it simple so everyday folks can use it.</h3>
          </div>
          </Fade>

        </div>

      </div>
    );
  }
}

export default Simplicity;



// WEBPACK FOOTER //
// ./src/assets/components/simplicity.js